import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { GiftIcon, XIcon } from 'lucide-react';
import { trackMeta } from './MetaPixel';
import { clearBasicCheckoutReturn, hasPendingBasicCheckoutReturn } from '../utils/checkoutReturn';
const EXIT_OFFER_URL = 'https://megapack-funcional-365.impultienda.ar/oferta-especial?store_id=a05de338-cc10-4d6b-9493-061df4fb0b81';
export function ExitIntentModal() {
  const [isOpen, setIsOpen] = useState(false);
  const hasShownRef = useRef(false);
  const checkoutTabWasOpenedRef = useRef(false);
  const closeModal = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    const openOfferAfterCheckoutReturn = () => {
      if (hasShownRef.current || !checkoutTabWasOpenedRef.current || !hasPendingBasicCheckoutReturn()) {
        return;
      }
      hasShownRef.current = true;
      clearBasicCheckoutReturn();
      setIsOpen(true);
      trackMeta('ExitIntentOfferViewed', {
        content_name: 'Oferta exclusiva — regreso checkout Arsenal',
        content_ids: ['arsenal-basico'],
        content_type: 'product'
      }, {
        custom: true
      });
    };
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' && hasPendingBasicCheckoutReturn()) {
        checkoutTabWasOpenedRef.current = true;
        return;
      }
      if (document.visibilityState === 'visible') {
        openOfferAfterCheckoutReturn();
      }
    };
    const handleWindowFocus = () => {
      openOfferAfterCheckoutReturn();
    };
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') closeModal();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleWindowFocus);
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleWindowFocus);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return <AnimatePresence data-id="element-188" data-mp="1j5ojs6n8t33r">
      {isOpen && <motion.div className="fixed inset-0 z-[70] flex items-center justify-center p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-189" data-mp="1n6i5quh4k7u0">
          <button type="button" className="absolute inset-0 cursor-default bg-[#020712]/85 backdrop-blur-sm" onClick={closeModal} aria-label="Cerrar oferta exclusiva" data-id="element-190" data-mp="vfkd1qercn8j" />

          <motion.section className="relative z-10 w-full max-w-md overflow-hidden rounded-3xl border border-brandOrange/40 bg-[#0c1626] p-6 text-center shadow-2xl md:p-8" initial={{
        opacity: 0,
        y: 24,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} transition={{
        duration: 0.28,
        ease: 'easeOut'
      }} role="dialog" aria-modal="true" aria-labelledby="exit-offer-title" aria-describedby="exit-offer-description" data-id="element-191" data-mp="14cuslnylyyj9">
            <button type="button" onClick={closeModal} className="absolute right-4 top-4 inline-flex h-9 w-9 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-brandOrange" aria-label="Cerrar oferta exclusiva" data-id="element-192" data-mp="3vbhbvn6hkgj6">
              <XIcon size={18} aria-hidden="true" data-id="element-193" data-mp="3cnm2sgltjqwe" />
            </button>

            <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl border border-brandOrange/30 bg-brandOrange/10 text-brandOrange" data-id="element-194" data-mp="37nzr4bln2ipp">
              <GiftIcon size={28} aria-hidden="true" data-id="element-195" data-mp="33nyz1o5ma906" />
            </div>

            <h2 id="exit-offer-title" className="pr-8 text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-196" data-mp="2yo4ctxwse7lg">
              ¡Esperá! Tenemos un{' '}
              <span className="text-brandOrange" data-id="element-197" data-mp="16jymtsw795y4">regalo para vos</span> 🎁
            </h2>
            <p id="exit-offer-description" className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-gray-300 md:text-base" data-id="element-198" data-mp="ssshhg68oe3b">
              Antes de irte, mirá esta oferta exclusiva con un descuento que solo
              está disponible ahora.
            </p>

            <div className="mt-7 grid gap-3" data-id="element-199" data-mp="nvjw76psntxu">
              <a href={EXIT_OFFER_URL} onClick={() => trackMeta('ExitIntentOfferClicked', {
            content_name: 'Oferta exclusiva — regreso checkout Arsenal',
            content_ids: ['arsenal-basico'],
            content_type: 'product'
          }, {
            custom: true
          })} className="inline-flex min-h-12 items-center justify-center rounded-full bg-brandOrange px-6 py-3 text-base font-bold text-white transition-colors hover:bg-brandOrange-hover focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2 focus:ring-offset-[#0c1626]" data-id="element-200" data-mp="9uzbu648dq28">
                Ver oferta
              </a>
              <button type="button" onClick={closeModal} className="inline-flex min-h-12 items-center justify-center rounded-full border border-white/10 bg-white/5 px-6 py-3 text-base font-semibold text-gray-300 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/40 focus:ring-offset-2 focus:ring-offset-[#0c1626]" data-id="element-201" data-mp="32207speafhac">
                No, gracias
              </button>
            </div>
          </motion.section>
        </motion.div>}
    </AnimatePresence>;
}